import { render, staticRenderFns } from "./CarouselImg.vue?vue&type=template&id=8cbe719a&scoped=true&"
import script from "./CarouselImg.vue?vue&type=script&lang=js&"
export * from "./CarouselImg.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImg.vue?vue&type=style&index=0&id=8cbe719a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbe719a",
  null
  
)

export default component.exports